export const ANGLE_THRESHOLD = 0.01; // 角度值
export const RADIAN_ANGLE_THRESHOLD = (ANGLE_THRESHOLD / 180) * Math.PI; // 弧度角度值
